import './Pill.css';

export default function Pill({ children, variant = 'default', size = 'md' }) {
  return (
    <span className={`pill pill--${variant} pill--${size}`}>
      {children}
    </span>
  );
}
